/**
 * A "minor conversion" analytics event sends the same event data as a normal
 * one using ConversionContext, however the context is derived from previous
 * non-minor events so additional context is not needed. For further
 * documentation on why this is see bigbingo-internals.js and/or
 * http://khanacademy.org/r/conversioncontext.
 */
import type {AnalyticsEvent} from "@khanacademy/event-schemas";
import type {
    MinorConversionData,
    MinorConversionId,
} from "@khan/analytics-learning-time";

import {formatConversions} from "./bigbingo-internals.ts";
import {actions, store} from "./store.ts";

/**
 * Sends a "minor conversion" event, representing low-level events such
 * as page requests that will inherit specific LearningTimeInfo from the last
 * published event or major conversion.
 */
export const publishAnalyticsEventForMinorConversion = (
    event: AnalyticsEvent,
    legacyConversionName?: MinorConversionId,
    eventTimestampOverride?: number,
): Promise<Response | null | undefined> => {
    const minorConversion: MinorConversionData = {
        id: legacyConversionName || "cedar_event",
        event,
    };
    const formatted = formatConversions(
        [minorConversion],
        eventTimestampOverride,
    );
    return store.dispatch(actions.markMinorConversions(formatted));
};
